import { SERVER, SPSERVER } from './env'

export const URL_CLIENTLIST = SERVER + 'sales/list'  // accountList页面接口

export const URL_FINDSALES = SERVER + 'sales/findById'  // accountList页面接口
export const URL_USERLIST = SERVER + 'user/list'  // userLise页面接口
export const URL_USERDELETE = SERVER + 'user/delete'  // userLise页面接口
export const URL_FINDUSER_BYEMAIL = SERVER + 'user/getByEmail'
export const POSITIONS_SEARCH = SERVER + "positions/search"  // dailyReport页面接口 -
// export const RELATIONSHIP_SEACHNODECODE = SERVER + "relationship/seachNodeCode"  // dailyReport页面接口 -
export const RELATIONSHIP_SEACHNODECODE = SERVER + "relationship2/seachParentId"  // dailyReport页面接口 -

export const URL_CREATEUSER = SERVER + 'user/create'  // 用户开户页面接口
export const URL_FINDUSER = SERVER + 'user/findUser'  // 用户查看页面接口
export const URL_FINDUSERID = SERVER + 'user/findUserId'  // 用户修改查询ID
export const URL_UPDATEUSER = SERVER + 'user/update'  // 用户开户页面接口

export const URL_SINGIN = SERVER + 'user/signin'          //登录
// export const URL_CREATE = SERVER+'sales/create'          //修改销售资料
export const URL_CREATE = SERVER + 'relationship2/create'          //修改销售资料
export const RELATIONSHIP_UPDATEPARENID = SERVER + 'relationship2/updateParentId'          //修改销售上级
export const RELATIONSHIP_UPDATENODECODE = SERVER + 'relationship2/updateNodeCode'          //修改销node_code*

export const RELATIONSHIP_SENDEMAILBYUPDATESALES = SERVER + 'relationship2/sendEmailByUpdateSales'          //修改销售密码时发送邮件
// export const URL_UPDATE = SERVER+'sales/update'          //修改销售资料
export const URL_UPDATE = SERVER + 'relationship2/update'          //修改销售资料
// export const URL_GETBYID = SERVER+'sales/getById'          //修改
export const URL_GETBYID = SERVER + 'relationship2/getSalesById'          //修改返回data
export const URL_SIGNOUT = SERVER + 'user/signout'          //修改
export const URL_CHANGEPWD = SERVER + 'user/changePwd'       //修改密码
export const URL_LOGINSALEPLATFORM = SERVER + 'user/loginSalePlatform'       //登录销售平台
export const URL_FINDNEXTLEVELBYID = SERVER + 'sales/findNextLevelById'       //搜索销售的下一级
export const URL_CHANGEPARENTSALES = SERVER + 'sales/changeLastLevelByIds'       //更改上一级
export const URL_GET_PROCESS_STATE = SERVER + 'sales/processState'       //获取更改上一级进度

// relationship表
// export const URL_CODEVERIFY = SERVER+'relationship/checkNodeCode'  // 开户代码code校验
export const URL_CODEVERIFY = SERVER + 'Relationship2/checkNodeCode'  // 开户代码code校验
export const URL_GETCODE = SERVER + 'Relationship2/getCodeById'  // 开户代码code校验
// export const URL_LASTCODEVERIFY = SERVER+'relationship/checkParentCode'  // 开户上级代码lastcode校验
export const URL_LASTCODEVERIFY = SERVER + 'relationship2/checkParentId'  // 开户上级代码lastcode校验
export const URL_RELATION = SERVER + 'relationship/list'       //关系树状图
export const URL_RELATIONSEARCH = SERVER + 'relationship/search'       //查询关系
export const URL_RELATION_GETNODEID = SERVER + 'relationship/getNodeId'       //获取账号查询关系
export const URL_GET_CLIENT_PARENT_INFO = SERVER + 'relationship/getClientParentInfo'

export const URL_UPLOAD = SERVER + 'files/upload'          //文件上传
export const URL_DOWNLOAD = SERVER + 'files/download'          //文件下载

export const URL_TESTLOGIN = SERVER + 'testLogIn'          //定时检测是否登录


//添加权限
export const URL_FINDALLROLE = SERVER + 'role/getList'   //查询所有的角色
export const URL_ADDROLE = SERVER + 'role/addRole'   //添加角色
export const URL_DELETEROLE = SERVER + 'role/deleteRole'   //删除角色

export const URL_FINDALLPRIVILEGE = SERVER + 'privilege/getList'   //查询所有的权限
export const URL_SAVEPRIVILEGE = SERVER + 'privilege/savePrivilege'   //保存权限


//直播间相关接口
export const URL_BROADCASTLIST = SERVER + 'broadcast/getList'   //获取直播间列表
export const URL_BROADCAST_CREATE = SERVER + 'broadcast/create'   //添加直播间
export const URL_BROADCAST_UPDATE = SERVER + 'broadcast/update'   //修改直播间
export const URL_BROADCAST_DELETE = SERVER + 'broadcast/delete'   //删除直播间


//专属推荐链接接口
export const URL_LINKSLIST = SERVER + 'sales/getLinks'   //获取专属推荐链接
export const URL_LINKSLIST_CREATE = SERVER + 'sales/createExclusiveLink'   //添加专属推荐链接
export const URL_LINKSLIST_DELETE = SERVER + 'sales/deleteLinks'   //删除专属推荐链接
export const URL_LINKSLIST_ADD = SERVER + 'sales/createLink'   //添加代理链接
export const URL_LINKSLIST_ENTITY = SERVER + 'sales/getLinksEntity'   //获取专属推荐链接 （切换entity时触发）
export const URL_MT_SERVER = SERVER + 'sales/getMTServer'   //获取平台类型
export const URL_MT_GROUP_CONFIG = SERVER + 'sales/getMTConfig'   //获取加点佣金杠杆


//销售绑定银行卡
export const URL_SALES_BANK_CREATE = SERVER + 'relationship2/createBank'   //新增
export const URL_SALES_BANK_DELETE = SERVER + 'relationship2/deleteBank'   //删除
export const URL_SALES_BANK_LIST = SERVER + 'relationship2/getBankList'   //查询



// WEBPACK FOOTER //
// ./src/api/api.js